mutation addDocumentToOnboarding($input: AddDocumentToOnboardingInput!) {
  document: addDocumentToOnboarding(input: $input) {
    id
    url
    name
  }
}
